//At time of writing this is based on PWA-1002
export function checkForOptionalBackgroundButton(testKitName: string, descriptorId: string): boolean {

    let shouldDisplay = false;

    if (testKitName && descriptorId) {
        if (testKitName.includes("AccuCount") && (descriptorId === "bRLUAMP" || descriptorId === "bRLUATP")) {
            shouldDisplay = true;
        }
    }

    return shouldDisplay;
}

export function isBehindCalibration(descriptors: any[], incomingDescriptor: any) {
    let calibrationSortOrder = 0;

    for (let descriptor of descriptors) {
        if (descriptor?.type?.includes('Calibration')) {
            calibrationSortOrder = descriptor.sortorder;
        }
    }
    
    let returnBool = incomingDescriptor.sortorder < calibrationSortOrder;
    return returnBool;
}